import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    name: '404',
    component: () => import('@/views/pages/404'),
  },
  {
    path: '/leaflet',
    component: () => import('@/views/pages/leaflet/index'),
    meta: {
      permission: false,
      title: '浦发银行海报这啊',
    },
    children: [
      {
        path: 'poster',
        name: 'Poster',
        component: () => import('@/views/pages/leaflet/poster'),
      },
      {
        path: 'newPoster',
        name: 'NewPoster',
        component: () => import('@/views/pages/leaflet/newPoster'),
      },
      {
        path: 'jump',
        name: 'Jump',
        component: () => import('@/views/pages/leaflet/jump'),
      },
      {
        path: 'jump1',
        name: 'Jump1',
        component: () => import('@/views/pages/leaflet/jump1'),
      },
      {
        path: 'jump2',
        name: 'Jump2',
        component: () => import('@/views/pages/leaflet/jump2'),
      },
      {
        path: 'jump3',
        name: 'Jump3',
        component: () => import('@/views/pages/leaflet/jump3'),
      },
      {
        path: 'pufa',
        name: 'Pufa',
        component: () => import('@/views/pages/leaflet/pufa'),
      },
      {
        path: 'pufa/rule',
        name: 'PufaRule',
        component: () => import('@/views/pages/leaflet/pufa-rule'),
      },
      {
        path: 'huaxia',
        name: 'Huaxia',
        component: () => import('@/views/pages/leaflet/huaxia'),
      },
      {
        path: 'huaxia1',
        name: 'Huaxia1',
        component: () => import('@/views/pages/leaflet/huaxia1'),
      },
      {
        path: 'huaxia2',
        name: 'Huaxia2',
        component: () => import('@/views/pages/leaflet/huaxia2'),
      },
      {
        path: 'huaxia3',
        name: 'Huaxia3',
        component: () => import('@/views/pages/leaflet/huaxia3'),
      },
    ],
  },
  {
    path: '/broker',
    name: 'Broker',
    component: () => import('@/views/pages/broker'),
  },
  {
    path: '/disgold',
    name: 'Disgold',
    component: () => import('@/views/pages/disgold'),
  },
  {
    path: '/cpost',
    name: 'Cpost',
    component: () => import('@/views/pages/cpost'),
  },
  {
    path: '/north/interim',
    name: 'Interim',
    component: () => import('@/views/pages/north/interim'),
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/pages/404'),
  },
];
const router = new VueRouter({
  mode: 'history',
  base: '/bank/',
  routes,
});

export default router;
